export default "__VITE_ASSET__29d1d0af__"